export const sendToConverterCheckout = (numeroPedido, formaPagamento) => {
  const pedidoString = numeroPedido.split('{')[0]

  const extract = `{${numeroPedido.match(/\{(.*)\}/)?.pop()}}`

  const pedidoEncoded = Buffer.from(pedidoString.replace(/\D/gim, '')).toString(
    'base64'
  )
  const pixPagamentoEncoded = Buffer.from(extract).toString('base64')
  const formaPagamentoEncoded = Buffer.from(formaPagamento).toString('base64')

  const urlRedirect = `${process.env.REACT_APP_URL_CHECKOUT}/conversao?p=${pedidoEncoded}&f=${formaPagamentoEncoded}&px=${pixPagamentoEncoded}`

  return (window.location.href = urlRedirect)
}
